import React from "react";
import {Table} from "antd";
import {numberColumn, stringColumn} from "../../../helpers/commonColumns";
import {DATE_FORMAT} from "../../../constants/dateFormat";

const licenceColumns = [
    stringColumn('softwareProductElement', 'Product Element'),
    stringColumn('expiryLicenceAction', 'Expiry Action'),
    numberColumn('quantity', 'Quantity'),
    {
        title: 'Expiry Date',
        dataIndex: 'expiryDate',
        key: 'expiryDate',
        render: (expiryDate) => {
            return expiryDate && expiryDate.format(DATE_FORMAT)
        },
    },
];

const CompanyLicenceConfirmationDatatable = ({licenceElements}) => {
    return <Table dataSource={licenceElements} columns={licenceColumns} />;
};

export default CompanyLicenceConfirmationDatatable;